export enum MediaType {
    List = 'list',
    Page = 'page',
    Rss = 'rss',
    Contact = 'contact',
    Web = 'web',
    Image = 'image',
    File = 'file',
    Video = 'video',
    NotAccepted = 'notAccepted',
    Audio = 'audio',
    Form = 'form'
}


export interface IMediaItem {
    mediaType: MediaType
    contentType: string,
    url: string,
    description: string,
    fileName: string,
    thumbnail: {
        url: string,
        contentType: string
    }
}